<template>
  <div class="create-jobs__main">
    <b-skeleton-wrapper>
      <b-card class="create-jobs__helper">
        <div class="header">
          <span style="font-size: 16px; display: block; color: #575757;">Add Job</span>
          <b-button class="close_btn" @click="() => {this.$emit('exit', true)}">{{ 'x' }}</b-button>
        </div>
        Use this flow to set up your desired job with tasks that will be completed in an ordered fashion.
        After selecting devices, creating tasks and executing - the tasks will be executed on each device in that subset.
      </b-card>
      <b-skeleton style="margin-bottom: 0; transition: all 2000ms;"
        :style="computedStepper === '100%' ? 'background-color: rgb(50 200 72 / 44%)' : 'background-color: rgb(50 181 200 / 44%)'"
        :width="computedStepper"></b-skeleton>
      <b-tabs content-class="mt-3 create-jobs__tab-content" v-model="jobFormIndex">
        <!-- JOB TAB -->
        <b-tab :title-link-class="'dm__tab-link'" title="Tasks" @click="jobFormIndex = 0;">
          <div class="create-jobs__tab-pane">
            <b-card class="create-jobs__tab-pane--available-selected">
              <div>
                <small>Available</small>
                <div class="create-jobs__tab-pane--list">
                  <div class="create-jobs__tab-pane--list-item" style="align-items: center;" v-for="task in computedAvailableTaskList" :key="task.type + '-AVAILABLE'">
                    <div
                      class="create-jobs__tab-pane--list-available-item-text"
                      :class="{
                        'create-jobs__available-item--added': task.type === addedTaskType,
                        'create-jobs__available-item--selected': !addedTaskType && selectedTask && selectedTask.type === task.type,
                        'create-jobs__available-item--disabled': addedTaskType && task.type !== addedTaskType
                      }"
                      @click="!(addedTaskType && task.type !== addedTaskType) && (selectedTask = task)">
                      {{ task.type }}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <p @click="tasksForm.tasks.length === 0 && addTask(selectedTask)" :class="selectedTask !== '' ? 'create-jobs__btn' : {}" :style="tasksForm.tasks.length > 0 ? 'color: #a5a5a5; cursor: not-allowed;' : ''">{{createJobBtnTitle}}</p>
                <div class="create-jobs__tab-pane--list">
                  <div v-for="(task, index) in computedSelectedTaskList" :key="task.type + index + '-SELECTED'">
                    <div class="create-jobs__tab-pane--list-item" v-if="task.type == TaskType.OTA">
                      <small>{{ 'Select Package'}}
                        <div v-for="(requirement, tIndex) in task.payloadTemplate" :key="`task-requirements-${index}-${tIndex}`">
                          <multiselect
                            open-direction="bottom"
                            :hideSelected='true'
                            :label="'label'"
                            :options="packageOptionsForSource(requirement.source)"
                            v-model="task.payload[requirement.id]"
                            placeholder="Select package"/>
                        </div>
                      </small>
                      <b-button @click="removeTask(index)" class="create-jobs__row-button">-</b-button>
                      <div class="create-jobs__batch-processing" v-if="task.supportsBatchSize">
                        <small><strong>Batch Processing</strong></small>
                        <div class="create-jobs__batch-processing-row">
                          <label for="batchSize">Batch size</label>
                          <b-input
                            id="batchSize"
                            type="number"
                            class="create-jobs__batch-size-input"
                            :min="batchSizeConfig.min"
                            :max="batchSizeConfig.max"
                            :state="getValidationState('batchSize')"
                            v-model.number="tasksForm.batchSize"
                            @input="onBatchSizeInput"
                            @blur="onBatchSizeBlur"
                          />
                          <b-button v-b-tooltip.hover.top="`Decrease batch size by ${batchSizeConfig.step}`" class="create-jobs__row-button" @click="decrementBatchSize">-</b-button>
                          <b-button v-b-tooltip.hover.top="`Increase batch size by ${batchSizeConfig.step}`" class="create-jobs__row-button" @click="incrementBatchSize">+</b-button>
                        </div>
                        <small v-if="errors.batchSize" class="text-danger">{{ errors.batchSize }}</small>
                        <small class="create-jobs__batch-processing-hint">Number of devices processed in each batch.</small>
                      </div>
                    </div>
                    <div class="create-jobs__tab-pane--list-item" v-else-if="task.type == TaskType.Configuration" >
                      <small>{{ 'Select Configuration' }}
                        <multiselect open-direction="bottom" :hideSelected='true' :label="'label'"
                           :options="task.payloadTemplate && Array.isArray(task.payloadTemplate) && task.payloadTemplate.length ?
                          task.payloadTemplate.map((template) => {
                            return template
                          }) : []"
                          @select="onConfigSelected"
                          :placeholder="Object.keys(task.payload).length
                            ? 'Add another configuration setting'
                            : 'Choose a configuration setting to add'"
                        />
                        <div v-for="(config, tIndex) in task.payload" :key="`task-requirements-${index}-${tIndex}`">
                          <label :for="config.name">{{ config.label }}</label>
                          <div style="display: flex; align-items: center; gap: 10px;">
                            <template v-if="config.type === 'duration'">
                              <div class="create-jobs__time-field">
                                <b-input :id="config.name + '-hours'" :value="getHoursFromSeconds(config.value)"
                                  type="number" class="create-jobs__time-input"
                                  :state="getValidationState(config.name)"
                                  @keydown="onTimeKeydown"
                                  @input="(val) => onTimeInput(task.validationMap, config, val, 'hours')"></b-input>
                                <span class="create-jobs__time-label">Hours</span>
                              </div>
                              <div class="create-jobs__time-field">
                                <b-input :id="config.name + '-minutes'" :value="getMinutesFromSeconds(config.value)"
                                  type="number" class="create-jobs__time-input"
                                  :state="getValidationState(config.name)"
                                  @keydown="onTimeKeydown"
                                  @input="(val) => onTimeInput(task.validationMap, config, val, 'minutes')"></b-input>
                                <span class="create-jobs__time-label">Minutes</span>
                              </div>
                            </template>
                            <b-input v-else :id="config.name" v-model="config.value" :type="config.type"
                              :placeholder="config.placeholder" :state="getValidationState(config.name)"
                              @input="validateField(task.validationMap, config)"></b-input>

                          <b-button @click="removeconfig(config)" class="create-jobs__row-button">X</b-button>
                        </div>
                          <small v-if="errors[config.name]" class="text-danger">
                            {{ errors[config.name] }}
                          </small>
                        </div>
                      </small>
                      <b-button @click="removeTask(index)" class="create-jobs__row-button">-</b-button>
                      <div class="create-jobs__batch-processing" v-if="task.supportsBatchSize">
                        <small><strong>Batch Processing</strong></small>
                        <div class="create-jobs__batch-processing-row">
                          <label for="batchSize">Batch size</label>
                          <b-input
                            id="batchSize"
                            type="number"
                            class="create-jobs__batch-size-input"
                            :min="batchSizeConfig.min"
                            :max="batchSizeConfig.max"
                            :state="getValidationState('batchSize')"
                            v-model.number="tasksForm.batchSize"
                            @input="onBatchSizeInput"
                            @blur="onBatchSizeBlur"
                          />
                          <b-button v-b-tooltip.hover.top="`Decrease batch size by ${batchSizeConfig.step}`" class="create-jobs__row-button" @click="decrementBatchSize">-</b-button>
                          <b-button v-b-tooltip.hover.top="`Increase batch size by ${batchSizeConfig.step}`" class="create-jobs__row-button" @click="incrementBatchSize">+</b-button>
                        </div>
                        <small v-if="errors.batchSize" class="text-danger">{{ errors.batchSize }}</small>
                        <small class="create-jobs__batch-processing-hint">Number of devices processed in each batch.</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="create-jobs__tab-pane--available-selected-divider"></div>
            </b-card>
          </div>
        </b-tab>
        
        <!-- DEVICES TAB -->
        <b-tab :title-link-class="'dm__tab-link'" title="Devices" @click="jobFormIndex = 1;">
          <div class="create-jobs__tab-pane">
            <small class="filter-label">Filtering</small>
            <!-- Active filter chips (Device ID, Advanced, Location) -->
            <div v-if="activeFiltersCount">
              <button v-for="f in activeFilters" :key="f.key" class="create-jobs__filter-chip" @click="onChipClear(f.key)">
                {{ f.label }} ×
              </button>
            </div>
            
            <div class="create-jobs__tab-pane--items">
              <div class="create-jobs__tab-pane--item">
                <b-form-select class="tenant-select" v-model="deviceForm.query.scope" :options="bedManagerService.tenants.data" @change="onTenantChange" />
              </div>
              <div class="create-jobs__tab-pane--item">
                <b-input
                  v-model="deviceForm.query.deviceId"
                  placeholder="ID"
                  @input="onDeviceIdSearchInput"
                />
              </div>
              <div style="padding: 5px;">
                <button class="create-jobs__filter-devices" @click="openAdvancedFilters" :disabled="!deviceForm.query.scope">
                  Advanced Filters
                </button>
              </div>
              <div class="create-jobs__tab-pane--item">
              <button class="create-jobs__filter-devices" :disabled="!createJobsTreeField || !Array.isArray(createJobsTreeField.treeData) || !createJobsTreeField.treeData.length" @click.self.stop="() => {
                createJobsTreeField.treeData.forEach((fac) => {
                  fac.expanded = false;
                  fac.selected = createJobsTreeField.filterActive ? fac.selected : false;
                  if (Array.isArray(fac.children)) {
                    fac.children.forEach((unit) => {
                      unit.expanded = false;
                      unit.selected = createJobsTreeField.filterActive ? unit.selected : false;
                      if (Array.isArray(unit.children)) {
                        unit.children.forEach((area) => {
                          area.expanded = false;
                          area.selected = createJobsTreeField.filterActive ? area.selected : false;
                        })
                      }
                    })
                  }
                });
                deviceTreeVisible = !deviceTreeVisible;
                }">
                  Location Filtering
                    <div v-if="deviceTreeVisible" v-click-outside="() => {
                      createJobsTreeField.treeData.forEach((fac) => {
                          fac.expanded = false;
                          fac.selected = createJobsTreeField.filterActive ? fac.selected : false;
                          if (Array.isArray(fac.children)) {
                            fac.children.forEach((unit) => {
                              unit.expanded = false;
                              unit.selected = createJobsTreeField.filterActive ? unit.selected : false;
                              if (Array.isArray(unit.children)) {
                                unit.children.forEach((area) => {
                                  area.expanded = false;
                                  area.selected = createJobsTreeField.filterActive ? area.selected : false;
                                })
                              }
                            })
                          }
                        });
                        deviceTreeVisible = false;
                      }"
                    style="
                      font-size: 10px;
                      position: absolute;
                      top: 38px;
                      right: 0px;
                      width: 500px;
                      background: white;
                      z-index: 2;
                      filter: drop-shadow(1px 1px 3px #c7c7c7);
                      border-radius: 5px;
                    ">
                    <themed-location-tree
                      @areasChange="onLocationAreasChange"
                      @searchChange="onLocationTreeSearchChange"
                      :activeLocationSearch="deviceForm.query.searchValue"
                      :fieldRef="createJobsTreeField"
                      :treeData="createJobsTreeField.treeData">
                      </themed-location-tree>
                  </div>
                </button>
              </div>
            </div>

            <b-card class="create-jobs__tab-pane--available-selected">
              <div>
                <small>
                  Available ({{  computedAvailableDeviceList.length }})
                </small>
               <span @click="openWarningModal" v-if="hasWarningBeds && computedAvailableDeviceList.length > 0" v-b-tooltip.hover.top.html="DisableTooltipMessage.DISABLE_INFO" style="position: absolute; top: 0.5%; right: 57%; cursor: pointer;">
                  <svg role="img" aria-label="Warning" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" :style="{ 'font-size': '20px', width: '24px', height: '24px'}">
                    <path fill="#eed202" d="M1 21h22L12 2 1 21z" />
                    <path fill="#ffffff" d="M12 16a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm1-8h-2v6h2V8z" />
                  </svg>
                </span>
              <p class="bm-select-all-text" style="position: absolute; top: 2%; right: 51%;" @click="toggleDevice(computedAvailableDeviceList)">Select All</p>
                <div class="create-jobs__tab-pane--list">
                      <div
                        class="create-jobs__tab-pane--list-item bm-device-row"
                        v-for="device in computedAvailableDeviceList"
                        :key="device.deviceId + '-AVAILABLE'"
                      >
                        <span v-b-tooltip.hover.top="getTooltipMessage(device)">
                          <b-button
                            class="create-jobs__row-button"
                            :disabled="device.disable || device.isUpToDate"
                            @click.stop="toggleDevice(device)"
                          >+</b-button>
                        </span>
                        <div class="bm-device-content">
                          <div
                            class="bm-device-header"
                            role="button"
                            @click="toggleDeviceDetails(device.deviceId)"
                          >
                            <div class="bm-device-title">
                              <strong>{{ formatDeviceId(device.deviceId) }}</strong>
                              <span v-if="device.locationName && device.unitName && device.areaName">
                                ({{ device.locationName }} &gt; {{ device.unitName }} &gt; {{ device.areaName }})
                              </span>
                              <span v-else>(UNASSIGNED)</span>
                            </div>

                            <div class="bm-device-chevron">
                              <span v-if="isDeviceExpanded(device.deviceId)">▲</span>
                              <span v-else>▼</span>
                            </div>
                          </div>
                          <b-collapse :visible="isDeviceExpanded(device.deviceId)">
                            <div class="bm-device-details">
                              <div v-if="expandedDeviceAttributes[device.deviceId]">
                                <div v-html="getFirmwareVersion(device.deviceId)"></div>
                              </div>
                              <div v-else class="bm-device-loading">
                                <span>No device info available</span>
                              </div>
                            </div>
                          </b-collapse>
                        </div>
                      </div>

                </div>
              </div>
              <div>
                <small>Selected ({{  this.deviceForm.deviceIds.length }})</small>
                <p style="position: absolute; top: 2%; right: 2%;" @click="removeAllDevices()" class="bm-select-all-text">Remove All</p>
                <div class="create-jobs__tab-pane--list">
                  <div class="create-jobs__tab-pane--list-item" v-for="device in computedSelectedDeviceList" :key="device.deviceId + '-SELECTED'">
                    <small class="create-jobs__tab-pane--list-item-text">
                      {{ device.deviceId }} ({{ device.model }})
                      <span v-if="device.location || device.area">({{ device.location || 'N/A' }} > {{ device.unit || 'N/A' }} > {{ device.area || 'N/A' }})</span>
                      <span v-else>(UNASSIGNED)</span>
                    </small>
                    <b-button @click="toggleDevice(device)" class="create-jobs__row-button">-</b-button>
                  </div>
                </div>
              </div>
              <div class="create-jobs__tab-pane--available-selected-divider"></div>
            </b-card>
            <b-modal id="warning-beds-modal" v-model="warningModalVisible" title="Attention Required" hide-footer centered modal-class="bm-modal" dialog-class="bm-modal__dialog" content-class="bm-modal__content" header-class="bm-modal__header" body-class="bm-modal__body" @hidden="resetUserAckSelection">
              <div class="bm-modal__topbar d-flex align-items-center w-100">
                <div class="bm-modal__badges d-flex align-items-center flex-wrap">
                  <b-badge variant="warning" class="mr-2">Unavailable: {{ unavailableBeds.length }}</b-badge>
                  <b-badge variant="info" class="mr-2">UserAckAwaited / UserAckAwaitedForRetry: {{ userAckBeds.length }}</b-badge>
                  <b-badge variant="danger">Stalled: {{ stalledInProgressBeds.length }}</b-badge>
                </div>

                <b-button size="sm" class="bm-modal__download ml-auto" @click="downloadWarningBeds()">
                  Download
                </b-button>
              </div>
              <div class="bm-modal__search">
                <b-input v-model="warningSearch" placeholder="Search Device ID..."/>
                <b-button size="sm" class="bm-modal__clear" :disabled="!warningSearch" @click="warningSearch = ''">
                  Clear
                </b-button>
              </div>

              <div class="bm-modal__fixed-area">
                <b-tabs v-model="warningModalTabIndex" nav-class="nav-tabs bm-modal__tabs" content-class="mt-3 bm-modal__tabs-content">
                  <b-tab title-link-class="dm__tab-link">
                    <template #title>
                      <span v-b-tooltip.hover.top="AttentionModalTabTooltips.UNAVAILABLE">
                        Unavailable (Queued / In-Progress)
                      </span>
                    </template>
                    <b-table
                      small striped hover
                      sort-icon-left
                      :items="filteredUnavailableBeds"
                      :fields="warningFieldsUnavailable"
                      sticky-header="320px"
                      show-empty
                      empty-text="No unavailable beds"
                      class="bm-modal__table"
                    />
                  </b-tab>

                  <b-tab title-link-class="dm__tab-link">
                    <template #title>
                      <span v-b-tooltip.hover.top="AttentionModalTabTooltips.USER_ACK">
                        UserAckAwaited / UserAckAwaitedForRetry
                      </span>
                    </template>
                    <div class="bm-modal__userack-actions">
                      <b-button size="sm" class="bm-modal__send-request" :disabled="disableSelectAllUserAck" @click="isAllSelectableUserAckSelected ? unselectAllUserAck() : selectAllUserAck()">
                        {{ isAllSelectableUserAckSelected ? 'Unselect All' : 'Select All' }}
                      </b-button>
                      <b-button
                        size="sm"
                        class="bm-modal__send-request"
                        :disabled="!selectedUserAckDeviceIds.length"
                        @click="sendUserAckRequest()">
                        Send Enable Bed Request
                      </b-button>
                    </div>

                    <b-table
                      small striped hover
                      sort-icon-left
                      :items="filteredUserAckBeds"
                      :fields="userAckFields"
                      sticky-header="320px"
                      show-empty
                      empty-text="No beds in User Ack state"
                      class="bm-modal__table"
                    >

                     <template #cell(select)="row">
                        <span v-b-tooltip.hover.top="row.item.isNotified === 1? 'Request already sent to enable this device.': null">
                        <b-form-checkbox
                          :value="row.item._rawDeviceId"
                          v-model="selectedUserAckDeviceIds"
                          :disabled="row.item.isNotified === 1"
                          @change="(val) => onUserAckCheckboxChange(row.item, val)"
                        /> </span>
                      </template>

                      <template #cell(deviceId)="row">
                        {{ row.item.deviceId }}
                      </template>

                      <template #cell(status)="row">
                        {{ row.item.status }}
                      </template>
                    </b-table>
                  </b-tab>

                  <b-tab title-link-class="dm__tab-link">
                    <template #title>
                      <span v-b-tooltip.hover.top="AttentionModalTabTooltips.STALLED">
                        Stalled In-Progress (&gt;1h)
                      </span>
                    </template>
                    <div class="bm-modal__userack-actions">
                      <b-button size="sm" class="bm-modal__send-request" :disabled="!filteredStalledBeds.length" @click="isAllSelectableStalledSelected ? unselectAllStalled() : selectAllStalled()">
                        {{ isAllSelectableStalledSelected ? 'Unselect All' : 'Select All' }}
                      </b-button>
                      <b-button
                        size="sm"
                        class="bm-modal__send-request"
                        :disabled="!selectedStalledDeviceIds.length"
                        @click="sendStalledRequest()">
                        Send Enable Bed Request
                      </b-button>
                    </div>

                    <b-table
                      small striped hover
                      sort-icon-left
                      :items="filteredStalledBeds"
                      :fields="stalledFields"
                      sticky-header="320px"
                      show-empty
                      empty-text="No stalled in-progress beds"
                      class="bm-modal__table"
                    >
                      <template #cell(select)="row">
                        <b-form-checkbox
                          :value="row.item._rawDeviceId"
                          v-model="selectedStalledDeviceIds"
                        />
                      </template>

                      <template #cell(deviceId)="row">
                        {{ row.item.deviceId }}
                      </template>

                      <template #cell(status)="row">
                        {{ row.item.status }}
                      </template>

                      <template #cell(lastUpdated)="row">
                        {{ row.item.lastUpdated }}
                      </template>
                    </b-table>
                  </b-tab>
                </b-tabs>
              </div>
            </b-modal>
            <bm-advanced-device-search-dialog
            ref="filterDialog"
            @filterApplied="handleAdvancedFilterApplied"
            @filterResetApplied="handleResetFilter">
            </bm-advanced-device-search-dialog>

            <skipped-devices-modal
              v-model="skippedDevicesModalVisible"
              :skipped="skippedDevices"
              :remaining="previewRemainingDeviceIds"
              :messages="skippedDevicesMessages"
              mode="preview"
              @closed="onSkippedDevicesModalClosed"
            />
          </div>
        </b-tab>

        <!-- PREVIEW TAB -->
        <b-tab :title-link-class="'dm__tab-link'" :title="`Preview & Submit`" @click="onPreviewTabClick">
          <div class="create-jobs__tab-pane">
            <b-card class="create-jobs__tab-pane--available-selected">
              <div>
                <small>Selected Devices</small>
                <div class="create-jobs__tab-pane--list">
                  <div class="create-jobs__tab-pane--list-item" v-for="device in computedSelectedDeviceList" :key="device.deviceId + '-SELECTED'">
                    <small class="create-jobs__tab-pane--list-item-text">
                      {{ device.deviceId }} ({{ device.model }})
                      <span v-if="device.location || device.area">({{ device.location || 'N/A' }} > {{ device.unit || 'N/A' }} > {{ device.area || 'N/A' }})</span>
                      <span v-else>(UNASSIGNED)</span>
                    </small>
                  </div>
                </div>
              </div>
              <div>
                <small>Selected Tasks</small>
                <div class="create-jobs__tab-pane--list">
                  <div class="create-jobs__tab-pane--list-item" v-for="(task, index) in computedSelectedTaskList" :key="task.type + index + '-SELECTED'">
                    <div class="create-jobs__task-preview">
                      <div class="create-jobs__task-heading">{{ task.type }}</div>
                      <table class="create-jobs__task-table" v-for="(key, tIndex) in Object.keys(task.payload)" :key="`task-requirements-${index}-${tIndex}`">
                        <tbody>
                          <tr v-for="propKey in previewKeysForTask(task, task.payload[key])" :key="`${key}-${propKey}`">
                            <td class="create-jobs__task-table-label">{{ previewLabelForTask(task, propKey) }}</td>
                            <td class="create-jobs__task-table-value" v-html="task.payload[key][propKey]"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="create-jobs__tab-pane--available-selected-divider"></div>
               <b-button :disabled="(!tasksForm.valid || !deviceForm.valid || errors.length || previewAllSkipped)" class="create-jobs__submit-btn" @click="onSubmit()">Submit</b-button>
            </b-card>
          </div>
        </b-tab>
      </b-tabs>
    </b-skeleton-wrapper>
  </div>
</template>
<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import BedManagerService from "../BedManager.service";
import DeviceAPIService from "../../../shared/services/api/Devices.service";
import ThemedLocationTree from "../../../shared/careai/components/ThemedLocationTree.vue";
import SkippedDevicesModal from "./SkippedDevicesModal.vue";
import { SKIPPED_DEVICES_MESSAGES, mapOtaBedStatus, ATTENTION_MODAL_TAB_TOOLTIPS, OTA_TERMINAL_STATUSES, OTA_ACTIVELY_PROCESSING_STATUSES } from "../bed-manager-constants";

const moment = require("moment");

const DisableTooltipMessage = {
  DEVICE_OFFLINE: 'Device is unavilable',
  DEVICE_INPROGRESS: 'This bed is still in progress in another job',
  DISABLE_INFO: 'Unavailable devices detected (Queued/In-Progress). <br /> Click to see details.',
}

const TaskType = {
  OTA: 'OTA',
  Configuration: 'Configuration'
}
const POPUP_ONLY_TASK_TYPES = new Set(["EnableBedRequest"]);

// Curated, ordered attribute labels for the OTA task Preview & Submit panel
const OTA_PREVIEW_LABELS = {
  _id: 'ID',
  label: 'Label',
  version: 'Version',
  s3Uri: 'S3 URI',
  signature: 'Signature',
  fileName: 'Filename',
  pathOnSensor: 'Path on Sensor',
  created: 'Created',
  createdBy: 'Created By',
};

// Ordered attribute labels for the Configuration task Preview & Submit panel
const CONFIGURATION_PREVIEW_LABELS = {
  label: 'Label',
  name: 'Name',
  type: 'Type',
  placeholder: 'Placeholder',
  default: 'Default',
  value: 'Value',
};

const getSelectedTenantValue = (service) => (
  service && service.tenants && service.tenants.selected && service.tenants.selected.value
    ? service.tenants.selected.value
    : null
);

Vue.use(VueToast);
Vue.use(Loading);
Vue.component('themed-location-tree', ThemedLocationTree);
export default {
  name: "CreateJobs",
  components: { SkippedDevicesModal },
  data() {
    return {
 // Utils
      TaskType,
      OTA_PREVIEW_LABELS,
      CONFIGURATION_PREVIEW_LABELS,
      console: console,
      moment: moment,
      DisableTooltipMessage,
      AttentionModalTabTooltips: ATTENTION_MODAL_TAB_TOOLTIPS,

       // Contains Domain State and Singleton Pattern Service(s)
      bedManagerService: BedManagerService,
      deviceService: DeviceAPIService,

 // Local State
      expandedAvailableDevices: new Set(),
      deviceTreeVisible: false,
      selectedTask: '',
      warningSearch: "",
      jobFormIndex: 0,
      selectedDevices: new Map(),
      advancedFilterOptions: [],
      deviceForm: {
        query: {
          tenant: null,
          models: [],
          // Persisted advanced filter state
          components: {},
          operation: 'AND',
          // Persisted POC tree state (location/unit/area) and pending search value
          pocTree: null,
          searchValue: '',
          scope: getSelectedTenantValue(BedManagerService),
        },
        deviceIds: [],
        valid: false,
      },
      tasksForm: {
        tasks: [],
        valid: false,
        batchSize: null,
      },
 // polling interval to fetch available devices
      pollingInterval: null,
       // Object to hold validation errors
      errors: {},

      warningModalVisible: false,

      warningFieldsUnavailable: [
        { key: "deviceId", label: "Device ID", sortable: true },
        { key: "jobId", label: "Job Id", sortable: true },
        { key: "status", label: "Status", sortable: true },
      ],

      userAckFields: [
        { key: "select", label: "", sortable: false, thStyle: { width: "40px" } },
        { key: "deviceId", label: "Device ID", sortable: true },
        { key: "jobId", label: "Job Id", sortable: true },
        { key: "status", label: "Status", sortable: true },
      ],

      stalledFields: [
        { key: "select", label: "", sortable: false, thStyle: { width: "40px" } },
        { key: "deviceId", label: "Device ID", sortable: true },
        { key: "jobId", label: "Job Id", sortable: true },
        { key: "status", label: "Status", sortable: true },
        {
          key: "lastUpdated",
          label: "Last Updated",
          sortable: true,
          sortByFormatted: (value, key, item) => item._rawLastUpdated,
        },
      ],

      skippedDevicesFields: [
        { key: "deviceId", label: "Device ID", sortable: true },
      ],

      selectedUserAckDeviceIds: [],
      selectedStalledDeviceIds: [],
      markingNotified: new Set(),
      warningModalTabIndex: 0,
      deviceIdSearchTimer: null,
      expandedDeviceAttributes: {}, // deviceId -> attributes cache

      // Skipped devices modal state
      skippedDevicesModalVisible: false,
      skippedDevices: [],
      skippedDevicesSearch: '',
      previewFilterTaskType: null,
      // Preview-tab filter state
      previewRemainingDeviceIds: [],
      previewAllSkipped: false,
      // Fingerprint of the last successful filter call (devices + packageVersion)
      // Used to skip redundant API calls when nothing has changed
      previewFilterFingerprint: null,

      // Create-jobs-local copy of the themed-location-tree header (deep cloned from service)
      createJobsTreeField: { treeData: [], filterActive: false },

      // All non-archived packages loaded from API for package dropdowns
      packageOptions: [],
    };
  },
 computed: {
    treeField() {
      return this.createJobsTreeField || { treeData: [], filterActive: false };
    },
    currentDMConfiguration() {
      if (this.bedManagerService.configuration) {
          return this.bedManagerService.configuration;
      }
      return null;
    },
    currentDeviceQuery() {
      if (this.deviceForm.query) {
          return this.deviceForm.query;
      }
      return null;
    },
    computedStepper() {
      let stepperState = 1;
      if (this.deviceForm.valid) stepperState += 33;
      if (this.tasksForm.valid) stepperState += 33;
      if (this.jobFormIndex === 2 && this.deviceForm.valid && this.tasksForm.valid) stepperState += 33;
      return `${stepperState}%`;
    },
    computedAvailableDeviceList() {
      // Use CreateJobs-specific cached devices
      let devices = (this.bedManagerService.createJobsDevices).filter(
        (device) => !this.deviceForm.deviceIds.includes(device.deviceId));

      return devices;
    },
    computedSelectedDeviceList() {
      return Array.from(this.selectedDevices.values());
    },
    computedAvailableTaskList() {
      var tasks =
        this.bedManagerService.configuration && Array.isArray(this.bedManagerService.configuration.tasks)
          ? this.bedManagerService.configuration.tasks
          : [];

      var POPUP_ONLY_TASK_TYPES = new Set(["EnableBedRequest"]);

      return tasks
        .filter(function (task) {
          if (task && task.hiddenInCreateJob) return false;
          if (POPUP_ONLY_TASK_TYPES.has(task.type)) return false;
          return true;
        })
        .map(function (task) {
          return {
            ...task,
            payload: {},
            payloadTemplate: task.frontendConfig && task.frontendConfig.payload ? task.frontendConfig.payload : [],
            validationMap: task.validationMap || {},
          };
        });
    },
      computedSelectedTaskList() {
      return this.tasksForm.tasks;
    },
    // Type of the single task actually added (persists across tab navigation, unlike selectedTask)
    addedTaskType() {
      return this.tasksForm.tasks.length ? this.tasksForm.tasks[0].type : null;
    },
    batchSizeConfig() {
      const cfg = (this.bedManagerService.configuration && this.bedManagerService.configuration.batchSize) || {};
      return {
        min: cfg.min,
        max: cfg.max,
        default: cfg.default,
        step: cfg.step,
      };
    },
    tenant() {
        return this.bedManagerService.tenants && this.bedManagerService.tenants.selected
          ? this.bedManagerService.tenants.selected
          : null;
    },
    createJobBtnTitle() {
      if (this.selectedTask === '') return 'Please select a Task';
      switch(this.selectedTask.type) {
        case 'OTA': return 'Add OTA Updates';
        case 'Configuration': return 'Add Configuration';
      }
    },
    selectableUserAckIds() {

      const rows = this.filteredUserAckBeds || [];
      return rows
        .filter(r => Number(r.isNotified) !== 1)
        .map(r => r._rawDeviceId);
    },

    isAllSelectableUserAckSelected() {
      const selected = this.selectedUserAckDeviceIds || [];
      if (!selected.length) return false;
      const selectable = this.selectableUserAckIds || [];
      if (!selectable.length) return false;
      const selectedSet = new Set(selected);
      return selectable.every(id => selectedSet.has(id));
    },
   // Rich device objects (from createJobsDevices) keyed by deviceId, used to enrich send payloads
    attentionDeviceById() {
      const map = {};
      (this.bedManagerService.createJobsDevices || []).forEach((d) => {
        if (d && d.deviceId) map[d.deviceId] = d;
      });
      return map;
    },

    // Authoritative device+status list from the status collection (source of truth for the
    // Attention Required modal), minus devices already selected for the job. This is intentionally
    // NOT gated by the (possibly filtered/paginated) createJobsDevices list.
    attentionDevices() {
      const selected = new Set(this.deviceForm.deviceIds || []);
      return (this.bedManagerService.deviceStatusList || [])
        .filter((d) => d && d.deviceId && !selected.has(d.deviceId));
    },

    unavailableBeds() {
      const terminal = new Set(OTA_TERMINAL_STATUSES.map((s) => String(s).toLowerCase()));

      return this.attentionDevices
        .filter((d) => {
          const statusLower = String(d.status || "").toLowerCase();

          const isUserAck =
            statusLower.includes("userack") ||
            statusLower.includes("acknowledgement");

          // EXCLUDE user ack devices from this tab
          if (isUserAck) return false;

          // "Unavailable" = has a non-terminal (queued / in-progress) status
          return d.status && !terminal.has(statusLower);
        })
        .map((d) => ({
          deviceId: this.formatDeviceId(d.deviceId),
          status: this.getDeviceStatus(d),
          jobId: this.getJobIdByDeviceId(d)
        }));
    },

      normalizedWarningSearch() {
        return String(this.warningSearch || "").trim().toLowerCase();
      },

      filteredUnavailableBeds() {
        const q = this.normalizedWarningSearch;
        if (!q) return this.unavailableBeds;

        return (this.unavailableBeds || []).filter((r) =>
          String(r.deviceId || "").toLowerCase().includes(q)
        );
      },

      filteredUserAckBeds() {
        const q = this.normalizedWarningSearch;
        if (!q) return this.userAckBeds;

        return (this.userAckBeds || []).filter((r) =>
          String(r.deviceId || "").toLowerCase().includes(q)
        );
      },

    userAckBeds() {
      const notifiedMap = this.bedManagerService.deviceNotifiedById || {};
      return this.attentionDevices
        .filter((d) => this.isUserAck(d))
        .map((d) => ({
          _rawDeviceId: d.deviceId,
          deviceId: this.formatDeviceId(d.deviceId),
          status: this.getDeviceStatus(d),
          jobId: this.getJobIdByDeviceId(d),
          isNotified: d.status === "BedEnableRequestSent" ? 1 : Number(notifiedMap[d.deviceId]) || 0,
        }));
    },

    hasAnyDisabledUserAckCheckbox() {
    return (this.userAckBeds || []).some(r => Number(r.isNotified) === 1);
  },

    userAckDevicesRaw() {
      return this.attentionDevices
        .filter((d) => this.isUserAck(d))
        .map((d) => this.attentionDeviceById[d.deviceId] || { deviceId: d.deviceId });
    },

    hasWarningBeds() {
      return this.unavailableBeds.length > 0 || this.userAckBeds.length > 0 || this.stalledInProgressBeds.length > 0;
    },

    stalledDevicesRaw() {
      const lastUpdatedMap = this.bedManagerService.deviceLastUpdatedById || {};
      const oneHourAgo = Date.now() - (60 * 60 * 1000);
      const terminal = new Set(OTA_TERMINAL_STATUSES.map((s) => String(s).toLowerCase()));
      const activelyProcessing = new Set(OTA_ACTIVELY_PROCESSING_STATUSES.map((s) => String(s).toLowerCase()));
      return this.attentionDevices
        .filter((d) => {
          const statusLower = String(d.status || '').toLowerCase();
          // must be in-progress (non-terminal)
          if (!d.status || terminal.has(statusLower)) return false;
          if (statusLower.includes('userack') || statusLower.includes('acknowledgement')) return false;
          if (activelyProcessing.has(statusLower)) return false;
          const lastUpdated = lastUpdatedMap[d.deviceId];
          if (!lastUpdated) return false;
          return new Date(lastUpdated).getTime() < oneHourAgo;
        })
        .map((d) => this.attentionDeviceById[d.deviceId] || { deviceId: d.deviceId });
    },

    stalledInProgressBeds() {
      const lastUpdatedMap = this.bedManagerService.deviceLastUpdatedById || {};
      return this.stalledDevicesRaw.map((d) => {
        const lastUpdated = lastUpdatedMap[d.deviceId];
        return {
          _rawDeviceId: d.deviceId,
          deviceId: this.formatDeviceId(d.deviceId),
          status: this.getDeviceStatus(d),
          jobId: this.getJobIdByDeviceId(d),
          lastUpdated: lastUpdated ? this.moment(lastUpdated).format('MMM Do, YYYY h:mm A') : 'Unknown',
          _rawLastUpdated: lastUpdated ? new Date(lastUpdated).getTime() : 0,
        };
      });
    },

    filteredStalledBeds() {
      const q = this.normalizedWarningSearch;
      if (!q) return this.stalledInProgressBeds;
      return (this.stalledInProgressBeds || []).filter((r) =>
        String(r.deviceId || '').toLowerCase().includes(q)
      );
    },

    disableSelectAllUserAck() {
      const q = this.normalizedWarningSearch;
      if (!q) return !this.userAckBeds.some(r => r.isNotified === 0);
      return !(this.userAckBeds || []).some(r => String(r.deviceId).toLowerCase() === String(q).toLowerCase() && r.isNotified === 0);
    },

    selectableStalledIds() {
      return (this.filteredStalledBeds || []).map(r => r._rawDeviceId);
    },

    isAllSelectableStalledSelected() {
      const selected = this.selectedStalledDeviceIds || [];
      if (!selected.length) return false;
      const selectable = this.selectableStalledIds || [];
      if (!selectable.length) return false;
      const selectedSet = new Set(selected);
      return selectable.every(id => selectedSet.has(id));
    },

    normalizedSkippedSearch() {
      return String(this.skippedDevicesSearch || '').trim().toLowerCase();
    },

    filteredSkippedDevices() {
      const q = this.normalizedSkippedSearch;
      const devices = Array.isArray(this.skippedDevices) ? this.skippedDevices : [];
      if (!q) return devices;
      return devices.filter(id =>
        String(id).toLowerCase().includes(q)
      );
    },

    skippedDevicesMessages() {
      return SKIPPED_DEVICES_MESSAGES[this.previewFilterTaskType] || SKIPPED_DEVICES_MESSAGES.OTA;
    }
    ,
    // Active filters to show as chips (Device ID, Advanced, Location)
    activeFilters() {
      const q = this.deviceForm && this.deviceForm.query ? this.deviceForm.query : {};
      const filters = [];

      if (q.deviceId && String(q.deviceId).trim() !== '') {
        const raw = String(q.deviceId).trim();
        let display = raw;
        if (raw.length > 3) display = '****' + raw.slice(-3);
        filters.push({ key: 'deviceId', label: `DeviceId: ${display}` });
      }

      const compCount = q.components && typeof q.components === 'object'
        ? Object.keys(q.components).filter(k => (q.components[k] || '').toString().trim() !== '').length
        : 0;
      if (compCount > 0) {
        filters.push({ key: 'advanced', label: `Advanced (${compCount})` });
      }

      // Location chip should only appear after user confirms selection (pocTree set by Ok)
      let areaCount = 0;
      try {
        const poc = this.deviceForm && this.deviceForm.query ? this.deviceForm.query.pocTree : null;
        if (poc && Array.isArray(poc.area)) areaCount = poc.area.length;
      } catch (e) { areaCount = 0; }

      if (areaCount > 0) filters.push({ key: 'location', label: `Location (${areaCount})` });

      return filters;
    },
    activeFiltersCount() {
      return (this.activeFilters || []).length;
    }
  },
  watch: {
    tenant() {
      this.deviceForm.query.scope = getSelectedTenantValue(this.bedManagerService);
    },

    currentDMConfiguration: {
      deep: true,
      handler() {}
    },
    currentDeviceQuery: {
      deep: true,
      handler() {
        // Models allowed are determined by task configuration / task selection
        const query = {
          model:
            this.computedSelectedTaskList.length ?
              Array.from(this.computedSelectedTaskList.reduce((iterator, val) => {
                if (Array.isArray(val.models)) {
                  val.models.forEach((model) => iterator.add(model));
                }
                return iterator;
              }, new Set()))
            : Array.from(this.currentDMConfiguration.tasks.reduce((iterator, val) => {
              if (Array.isArray(val.models)) {
                val.models.forEach((model) => iterator.add(model));
              }
              return iterator;
            }, new Set()))
        };

        if (this.deviceForm.query.scope) {
          const tenant = this.bedManagerService.tenants.data.find((item) => item.value === this.deviceForm.query.scope);
          this.bedManagerService.tenants.selected = tenant;
          this.bedManagerService.fetchCreateJobsDevices(this.deviceForm.query.scope);
        }
      }
    },
    'bedManagerService.devices.headers': {
      deep: true,
      handler() {
        this.initializeCreateJobsTreeField();
      }
    },

    'bedManagerService.stalledJobDeviceIds': {
      deep: true,
      handler(ids) {
        if (!Array.isArray(ids) || !ids.length) return;
        // Pre-select the stalled device IDs and open the Attention Required modal on the Stalled tab
        this.$nextTick(() => {
          this.selectedStalledDeviceIds = [...ids];
          this.bedManagerService.stalledJobDeviceIds = [];
          this.warningModalTabIndex = 2; // Stalled In-Progress tab
          this.warningModalVisible = true;
        });
      }
    },

     deviceForm: {
      deep: true,
      handler(value) {
        if (Array.isArray(value.deviceIds) && value.deviceIds.length) {
          value.valid = true;
        } else value.valid = false;
        // Device list changed — next Preview visit must re-run the filter
        this.previewFilterFingerprint = null;
      },
    },
    tasksForm: {
      deep: true,
      handler(form) {
        if (Array.isArray(form.tasks) && form.tasks.length) {
          let valid = true;
          const batchCfg = this.batchSizeConfig;
          const batchSize = Number(form.batchSize);
          const batchSizeValid = form.batchSize !== null && form.batchSize !== undefined && form.batchSize !== '' &&
            Number.isInteger(batchSize) && batchSize >= batchCfg.min && batchSize <= batchCfg.max;

          for(let task of form.tasks){
            if(task.type == TaskType.OTA){
              task.payloadTemplate.forEach((req) => {
                if (!task.payload[req.id]){
                  valid = false
                  form.valid = valid;
                  return
                }
              })
            }
            else if(task.type == TaskType.Configuration){
              var inValidValues = Object.values(task.payload).some((val) => val.value == undefined || val.value == "" || val.value == 0)
              if(((Object.keys(this.errors).length > 0) || Object.keys(task.payload).length == 0 || inValidValues)){
                valid = false;
                form.valid = valid;
                return
              }
            }
          }
          form.valid = valid && batchSizeValid;
        } else {
          form.valid = false
        }
        // Package selection changed — next Preview visit must re-run the filter
        this.previewFilterFingerprint = null;
      }
    }
  },
  mounted() {
    Vue.directive('click-outside', {
        bind(el, binding, vnode) {
            var vm = vnode.context;
            var callback = binding.value;

            el.clickOutsideEvent = function (event) {
                if (!(el == event.target || el.contains(event.target))) {
                    return callback.call(vm, event);
                }
            };
            document.body.addEventListener('click', el.clickOutsideEvent);
        },
        unbind(el) {
            document.body.removeEventListener('click', el.clickOutsideEvent);
        }
    });
    // Carries over only non-POC device pane query state for QOL (avoid copying location/unit/area)
    // it will help to copy tenant, but not the deviceId search term - each tab starts unfiltered by deviceId
    try {
      const copyExclude = new Set(['location', 'unit', 'area', 'pocTree', 'searchValue', 'deviceId']);
      Object.keys(this.bedManagerService.devices.query).forEach((key) => {
        if (copyExclude.has(key)) return;
        const val = this.bedManagerService.devices.query[key];
        if (val !== undefined && val !== null && !(Array.isArray(val) && val.length === 0) && val !== '') {
          this.deviceForm.query[key] = val;
        }
      });
      this.deviceForm.query = { ...this.deviceForm.query };
    } catch (err) {
      console.error('Error copying device query state to CreateJobs', err);
    }

    this.pollingInterval = setInterval(() => {
        const tenant = getSelectedTenantValue(BedManagerService);
        if (tenant) {
          this.bedManagerService.fetchDevicesAndStatus(tenant);
        }
    }, 10000)

    // preload active packages for OTA dropdowns
    this.fetchAllPackages().catch((err) => {
      console.error('Failed to preload packages for CreateJobs:', err);
    });

    // Initialize local tree header copy for CreateJobs
    this.initializeCreateJobsTreeField();

  },
  unmounted() {},
  methods: {
    initializeCreateJobsTreeField() {
      try {
        const headers = Array.isArray(this.bedManagerService.devices.headers) ? this.bedManagerService.devices.headers : [];
        const pocHeader = headers.find((h) => h && h.key === 'poc');
        const rawTree = pocHeader && Array.isArray(pocHeader.treeData) ? pocHeader.treeData : [];
        const clonedTree = JSON.parse(JSON.stringify(rawTree));

        // sanitize cloned tree: clear expanded/selected on all nodes
        const sanitize = (nodes) => {
          if (!Array.isArray(nodes)) return;
          nodes.forEach((n) => {
            n.expanded = false;
            n.selected = false;
            n.active = false;
            if (Array.isArray(n.children)) sanitize(n.children);
          });
        };
        sanitize(clonedTree);

        this.createJobsTreeField = { treeData: clonedTree, filterActive: true };
        // ensure any pending search for CreateJobs is empty on open
        this.deviceForm.query.searchValue = this.deviceForm.query.searchValue || '';
      } catch (err) {
        this.createJobsTreeField = { treeData: [], filterActive: false };
        console.error('Failed to initialize createJobsTreeField', err);
      }
    },
    // Clear previously applied filters in CreateJobs. Preserves tenant `scope`.
    clearFilters(preserveKeys = []) {
      try {
        const preserve = new Set(['scope', ...preserveKeys]);
        const q = this.deviceForm && this.deviceForm.query ? this.deviceForm.query : {};
        Object.keys(q).forEach((k) => {
          if (!preserve.has(k)) {
            try { delete q[k]; } catch (e) { q[k] = undefined; }
          }
        });
        // ensure query object reference changes to trigger reactivity
        this.deviceForm.query = { ...(this.deviceForm.query || {}) };

        // clear any selected/expanded nodes in the local tree copy unless POC tree or searchValue are preserved
        const locationKeys = ['pocTree', 'searchValue'];
        const keepTree = locationKeys.some((k) => preserve.has(k));
        try {
          if (!keepTree) {
            this.deviceForm.query.searchValue = '';
            if (this.createJobsTreeField && Array.isArray(this.createJobsTreeField.treeData)) {
              const clonedTree = JSON.parse(JSON.stringify(this.createJobsTreeField.treeData));
              const sanitizeNodes = (nodes) => {
                if (!Array.isArray(nodes)) return;
                nodes.forEach((n) => {
                  n.expanded = false;
                  n.selected = false;
                  n.active = false;
                  if (Array.isArray(n.children)) sanitizeNodes(n.children);
                });
              };
              sanitizeNodes(clonedTree);
              this.createJobsTreeField = { ...this.createJobsTreeField, treeData: clonedTree, filterActive: false };
            } else if (this.createJobsTreeField) {
              this.createJobsTreeField.filterActive = false;
            }
          } else if (this.createJobsTreeField) {
            // preserve current tree selection state but reset filterActive (will be set by caller)
            this.createJobsTreeField = { ...this.createJobsTreeField, filterActive: false };
          }
        } catch (e) {
          if (this.createJobsTreeField) this.createJobsTreeField.filterActive = false;
        }
      } catch (err) {
        console.error('clearFilters error', err);
      }
    },
    // Called on each input change in device ID field (debounced live search)
    onDeviceIdSearchInput() {
      this.clearFilters(['deviceId']);
      // clear existing timer
      if (this.deviceIdSearchTimer) clearTimeout(this.deviceIdSearchTimer);
      // debounce 300ms
      this.deviceIdSearchTimer = setTimeout(() => {
        if (!this.deviceForm.query.scope) return;
        // call service with deviceId override
        this.bedManagerService.fetchCreateJobsDevices(this.deviceForm.query.scope, { deviceId: this.deviceForm.query.deviceId });
      }, 300);
    },


    async toggleDeviceDetails(deviceId) {
      if (!deviceId) return;

      const isExpanding = !this.expandedAvailableDevices.has(deviceId);

      if (isExpanding) {
        this.expandedAvailableDevices.add(deviceId);

        // Fetch expanded attributes if not already cached
        if (!this.expandedDeviceAttributes[deviceId]) {
          window.showLoading('Fetching device attributes...');
          const tenant = getSelectedTenantValue(this.bedManagerService);
          if (tenant) {
            try {
              const attrs = await this.bedManagerService.fetchExpandedDeviceAttributes(tenant, deviceId);
              if (attrs) {
                this.expandedDeviceAttributes[deviceId] = attrs;
              }
            } catch (error) {
              console.error(`Failed to fetch attributes for ${deviceId}:`, error);
            } finally {
              window.hideLoading();
            }
          }
        }
      } else {
        this.expandedAvailableDevices.delete(deviceId);
      }

      this.expandedAvailableDevices = new Set(this.expandedAvailableDevices);
    },

    isDeviceExpanded(deviceId) {
      return this.expandedAvailableDevices.has(deviceId);
    },

    getFirmwareVersion(deviceId) {
      const attrs = this.expandedDeviceAttributes[deviceId];
      if (!attrs) return '<span class="fw-version-none">No version data</span>';

      const v = attrs.version || {};
      const bedData = attrs.bedData || {};

      // Check if there's any actual data to display
      const hasVersionData = Object.entries(v).some(([key, val]) =>
        val && String(val).trim() !== ''
      );
      const hasBedData = Object.keys(bedData).length > 0;

      if (!hasVersionData && !hasBedData) {
        return '<span class="fw-no-info">No device info</span>';
      }

      const versionFields = [
        { key: 'GatewaySWVersionNumber', label: 'Gateway SW' },
        { key: 'MainControllerSWVersion', label: 'Main Controller' },
        { key: 'BrakeSWVersion', label: 'Brake' },
        { key: 'DisplayControllerSWVersion', label: 'Display' },
        { key: 'ZoomControllerSWVersion', label: 'Zoom' },
        { key: 'RIBBedSWVersion', label: 'RIB Bed' },
        { key: 'RIBWallSWVersion', label: 'RIB Wall' },
        { key: 'MotionControllerSWVersion', label: 'Motion Controller' },
        { key: 'ScaleSWVersion', label: 'Scale' },
        { key: 'RIBWallSmartTvSWVersion', label: 'RIB Wall TV' },
        { key: 'RIBBedSmartTvSWVersion', label: 'RIB Bed TV' },
        { key: 'WalliWrapSWVersion', label: 'Walli Wrap' },
        { key: 'BediWrapSWVersion', label: 'Bedi Wrap' }
      ];

      const versionRows = versionFields
        .map(f => {
          const val = v[f.key];
          const hasValue = val && String(val).trim() !== '';
          return `<tr class="fw-row">
            <td class="fw-label">${f.label}</td>
            <td class="fw-value ${hasValue ? 'fw-has' : 'fw-missing'}">${hasValue ? this.escapeHtml(String(val)) : '<span class="fw-empty">—</span>'}</td>
          </tr>`;
        })
        .join('\n');

      const bedDataRows = Object.entries(bedData)
        .map(([key, value]) => {
          const displayValue = typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value);
          return `<tr class="bd-row">
            <td class="bd-key">${this.escapeHtml(key)}</td>
            <td class="bd-value ${value !== '' && value != null ? 'bd-has' : 'bd-missing'}">${value !== '' && value != null ? this.escapeHtml(displayValue) : '<span class="bd-empty">—</span>'}</td>
          </tr>`;
        })
        .join('\n');

      return `<div class="fw-table">
        <h4 class="fw-title">Device Info</h4>
        <table class="fw-grid">
          <thead><tr><th>Component</th><th>Version</th></tr></thead>
          <tbody>${versionRows}${bedDataRows}</tbody>
        </table>
      </div>`;
    },

    escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    },

    onTenantChange() {
      if (this.deviceForm.query.scope) {
        const tenant = this.bedManagerService.tenants.data.find((item) => item.value === this.deviceForm.query.scope);
        this.bedManagerService.tenants.selected = tenant;
        this.removeAllDevices();
      }
    },

    openWarningModal() {
      this.warningModalVisible = true;
    },

    resetUserAckSelection() {
      this.selectedUserAckDeviceIds = [];
      this.markingNotified = new Set();
      this.selectedStalledDeviceIds = [];
      this.warningModalTabIndex = 0;
    },

    formatDeviceId(deviceId) {
      if (!deviceId) return "";
      return String(deviceId).replace(/^cai:SYK/i, "");
    },

    isUserAck(device) {
      const map = this.bedManagerService.deviceStatusById || {};
      const status = map[device.deviceId];
      if (!status) return false;

      return (
        status === "UserAckAwaited" ||
        status === "UserAckAwaitedforRetry" ||
        status === "WaitingForUserAcknowledgement" ||
        status === "BedEnableRequestSent" ||
        String(status).toLowerCase().includes("userack") ||
        String(status).toLowerCase().includes("acknowledgement")
      );
    },


    getDeviceStatus(device) {
      const map = this.bedManagerService.deviceStatusById || {};
      const raw = map[device.deviceId] || "Unknown";
      return mapOtaBedStatus(raw);
    },
    getJobIdByDeviceId(device) {
      const map = this.bedManagerService.deviceStatusById || {};
      return map['_' + device.deviceId] || "Unknown";
    },

    downloadWarningBeds() {
      const headers = ["Device ID", "Status"];

      const rows = [
        ...this.unavailableBeds.map((x) => [x.deviceId, x.status]),
        ...this.userAckBeds.map((x) => [x.deviceId, x.status]),
        ...this.stalledInProgressBeds.map((x) => [x.deviceId, x.status]),
      ];

      const csvContent = [headers.join(","), ...rows.map((r) => r.map((v) => `"${String(v).replace(/"/g, '""')}"`).join(","))].join("\n");
      this.bedManagerService.exportToCSV(csvContent, "Beds_Needing_Attention");
    },


    onUserAckCheckboxChange(rowItem, val) {

    const deviceId = rowItem && rowItem._rawDeviceId ? rowItem._rawDeviceId : null;
    if (!deviceId) return;

    if (Number(rowItem.isNotified) === 1) {

    this.selectedUserAckDeviceIds = (this.selectedUserAckDeviceIds || []).filter(id => id !== deviceId);
    }
    },


    async sendUserAckRequest() {
  const tenant = getSelectedTenantValue(this.bedManagerService);

  const selectedSet = new Set(this.selectedUserAckDeviceIds || []);
  const selectedDevices = this.userAckDevicesRaw.filter((d) => selectedSet.has(d.deviceId));
  if (!selectedDevices.length) return;

  const deviceIds = selectedDevices.map(d => d.deviceId);

  const payload = {
    tenant,
    devices: selectedDevices.map((device) => ({
      deviceId: device.deviceId,
      mac: device.serial,
      firmwareVersion:
      (device &&
        device.properties &&
        device.properties.latestCompletedJob &&
        device.properties.latestCompletedJob.version) || "",
      area: device.areaId,
      unit: device.unitId,
      location: device.locationId,
     metadata:
      (device &&
        device.properties &&
        device.properties.bedData &&
        device.properties.bedData.PropertiesResponse) || "",
    })),
    taskList: [{ type: "EnableBedRequest", payload: {} }],
  };

  window.showLoading('Sending enable request...');
  try {
    // 1) create job
    const res = await Vue.prototype.$DeviceManagerAPIService.postJobs(payload);

  // 2) mark notified ONLY HERE (not on checkbox click)
  await Vue.prototype.$DeviceManagerAPIService.markBedsNotified({
    scope: tenant,
    deviceIds,
    isNotified: 1,
  });

  // 3) refresh UI maps
  await this.bedManagerService.fetchDevicesAndStatus(tenant);

  window.hideLoading();

  this.$toast.open({
    message: `Job created successfully for ${deviceIds.length} bed(s).`,
    type: "success",
    duration: 3000,
  });

  this.selectedUserAckDeviceIds = [];
  return res;
  } catch (error) {
    window.hideLoading();
    throw error;
  }
    },

    async selectAllUserAck() {
  const ids = (this.filteredUserAckBeds || [])
    .filter(x => Number(x.isNotified) !== 1)
    .map(x => x._rawDeviceId);

  if (!ids.length) return;

  this.selectedUserAckDeviceIds = Array.from(
    new Set([...(this.selectedUserAckDeviceIds || []), ...ids])
  );

  this.$toast.open({
    message: `Selected ${ids.length} bed(s).`,
    type: "success",
    duration: 2500,
  });
    },

    unselectAllUserAck() {
      this.selectedUserAckDeviceIds = [];
    },

    async sendStalledRequest() {
      const tenant = getSelectedTenantValue(this.bedManagerService);
      const selectedSet = new Set(this.selectedStalledDeviceIds || []);
      const selectedDevices = this.stalledDevicesRaw.filter((d) => selectedSet.has(d.deviceId));
      if (!selectedDevices.length) return;

      const deviceIds = selectedDevices.map(d => d.deviceId);

      const payload = {
        tenant,
        devices: selectedDevices.map((device) => ({
          deviceId: device.deviceId,
          mac: device.serial,
          firmwareVersion:
            (device &&
              device.properties &&
              device.properties.latestCompletedJob &&
              device.properties.latestCompletedJob.version) || "",
          area: device.areaId,
          unit: device.unitId,
          location: device.locationId,
          metadata:
            (device &&
              device.properties &&
              device.properties.bedData &&
              device.properties.bedData.PropertiesResponse) || "",
        })),
        taskList: [{ type: "EnableBedRequest", payload: {} }],
      };

      window.showLoading('Sending enable request...');
      try {
        const res = await Vue.prototype.$DeviceManagerAPIService.postJobs(payload);
        await this.bedManagerService.fetchDevicesAndStatus(tenant);
        window.hideLoading();
        this.$toast.open({
          message: `Job created successfully for ${deviceIds.length} bed(s).`,
          type: "success",
          duration: 3000,
        });
        this.selectedStalledDeviceIds = [];
        return res;
      } catch (error) {
        window.hideLoading();
        throw error;
      }
    },

    async selectAllStalled() {
      const ids = (this.filteredStalledBeds || []).map(x => x._rawDeviceId);
      if (!ids.length) return;
      this.selectedStalledDeviceIds = Array.from(
        new Set([...(this.selectedStalledDeviceIds || []), ...ids])
      );
      this.$toast.open({
        message: `Selected ${ids.length} bed(s).`,
        type: "success",
        duration: 2500,
      });
    },

    unselectAllStalled() {
      this.selectedStalledDeviceIds = [];
    },

     onConfigSelected(option) {
      let task = this.tasksForm.tasks.find((task)=> task.type == TaskType.Configuration)
      if(!task.payload[option.label]){
        let label = option.label
        const configOption = { ...option };
        if (configOption.type === 'duration' && configOption.default && !configOption.value) {
          configOption.value = parseInt(configOption.default) || 0;
        }
        task.payload = { ...task.payload, [label] : configOption }
      }
    },

    removeconfig(option){
      let task = this.tasksForm.tasks.find((task)=> task.type == TaskType.Configuration)
      delete task.payload[option.label]
      task.payload = {...task.payload}
      this.$delete(this.errors, option.name);
    },

    validateField(validationMap, field) {
      const value = field.value
      const rules = validationMap[field.name] || {};
      let error = null;

      if (rules.required && !value) {
        error = `${field.label} is required.`;
      } else if (rules.minLength && value.length < rules.minLength) {
        error = `${field.label} must be at least ${rules.minLength} characters.`;
      } else if (rules.min !== undefined && value < rules.min) {
        if (field.type === 'duration') {
          error = `${field.label} must be at least ${this.formatSecondsToTime(rules.min)}.`;
        } else {
          error = `${field.label} must be at least ${rules.min}.`;
        }
      } else if (rules.max !== undefined && value > rules.max) {
        if (field.type === 'duration') {
          error = `${field.label} must not exceed ${this.formatSecondsToTime(rules.max)}.`;
        } else {
          error = `${field.label} must be lesser than ${rules.max}.`;
        }
      } else if (rules.pattern) {
        try {
          const pattern = new RegExp(rules.pattern);
          if (!pattern.test(value)) {
            error = rules.patternMessage || `${field.label} format is invalid.`;
          }
        } catch (e) {
          console.error(`Invalid RegExp pattern for ${field.name}:`, rules.pattern);
        }
      }

      if (error) {
        this.$set(this.errors, field.name, error);
      } else {
        this.$delete(this.errors, field.name);
      }
    },

    getValidationState(fieldName) {
      if (this.errors[fieldName]) return false;
      return null;
    },

    getHoursFromSeconds(seconds) {
      const val = parseInt(seconds) || 0;
      return Math.floor(val / 3600);
    },

    getMinutesFromSeconds(seconds) {
      const val = parseInt(seconds) || 0;
      return Math.floor((val % 3600) / 60);
    },

    formatSecondsToTime(seconds) {
      const val = parseInt(seconds) || 0;
      const hours = Math.floor(val / 3600);
      const minutes = Math.floor((val % 3600) / 60);
      const parts = [];
      if (hours > 0) parts.push(`${hours} hour${hours !== 1 ? 's' : ''}`);
      if (minutes > 0) parts.push(`${minutes} minute${minutes !== 1 ? 's' : ''}`);
      return parts.length ? parts.join(' ') : '0 minutes';
    },

    onTimeKeydown(event) {
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (allowedKeys.includes(event.key)) return;
      if (event.ctrlKey || event.metaKey) return;
      if (event.target.value.length >= 2) {
        event.preventDefault();
      }
    },

    onTimeInput(validationMap, config, val, unit) {
      const currentSeconds = parseInt(config.value) || 0;
      let hours = Math.floor(currentSeconds / 3600);
      let minutes = Math.floor((currentSeconds % 3600) / 60);

      if (unit === 'hours') {
        hours = Math.min(parseInt(val) || 0, 24);
      } else {
        minutes = Math.min(parseInt(val) || 0, 59);
      }

      const newValue = (hours * 3600) + (minutes * 60);
      // Force Vue to re-render the input when clamping doesn't change the value
      this.$set(config, 'value', newValue);
      this.validateField(validationMap, config);
    },

    async onPreviewTabClick() {
      this.jobFormIndex = 2;

      const otaTask = this.tasksForm.tasks.find(t => t.type === TaskType.OTA);
      const configurationTask = this.tasksForm.tasks.find(t => t.type === TaskType.Configuration);
      const hasDevices = this.deviceForm.deviceIds.length > 0;

      if (!hasDevices) return;

      if (otaTask && configurationTask) {
        this.$toast.open({
          message: 'Only one task type is allowed for preview filtering. Please keep either OTA or Configuration.',
          type: 'warning',
          duration: 4000
        });
        return;
      }

      let filterTask = null;
      if (otaTask && otaTask.payload && otaTask.payload.package && otaTask.payload.package.version) {
        filterTask = {
          type: otaTask.type,
          payload: { package: { version: otaTask.payload.package.version } }
        };
      } else if (configurationTask) {
        const configPayload = { Configuration: {} };
        Object.values(configurationTask.payload || {}).forEach((v) => {
          if (v && v.name) configPayload.Configuration[v.name] = v.value;
        });

        const hasConfigValue = Object.keys(configPayload.Configuration).length > 0;
        if (hasConfigValue) {
          filterTask = {
            type: configurationTask.type,
            payload: configPayload
          };
        }
      }

      if (!filterTask) return;

      this.previewFilterTaskType = filterTask.type;

      // Build fingerprint from sorted device IDs + selected preview filter task payload
      const currentFingerprint = [
        [...this.deviceForm.deviceIds].sort().join(','),
        JSON.stringify(filterTask)
      ].join('|');

      // Skip API call if nothing changed since the last successful filter
      if (currentFingerprint === this.previewFilterFingerprint) return;

      window.showLoading('Checking devices for updates...');
      try {
        const payload = {
          tenant: getSelectedTenantValue(this.bedManagerService),
          devices: Array.from(this.selectedDevices.values()).map(d => ({ deviceId: d.deviceId })),
          taskList: [filterTask]
        };

        const result = await Vue.prototype.$DeviceManagerAPIService.filterJobDevices(payload);
        const remaining = Array.isArray(result && result.remaining) ? result.remaining : [];
        const skipped = Array.isArray(result && result.skipped) ? result.skipped : [];

        this.previewRemainingDeviceIds = remaining;
        this.previewAllSkipped = remaining.length === 0 && skipped.length > 0;

        // Persist fingerprint so repeat tab-switches don't re-call the API
        this.previewFilterFingerprint = currentFingerprint;

        // Remove up-to-date devices from the selected set
        if (skipped.length > 0) {
          const remainingSet = new Set(remaining);
          this.deviceForm.deviceIds = this.deviceForm.deviceIds.filter(id => remainingSet.has(id));
          const newMap = new Map();
          this.selectedDevices.forEach((device, id) => {
            if (remainingSet.has(id)) newMap.set(id, device);
          });
          this.selectedDevices = newMap;

          this.openSkippedDevicesModal(skipped);
        }
      } catch (error) {
        console.error('filter-devices failed:', error);
        this.$toast.open({ message: 'Could not run preview filtering. You may still submit.', type: 'warning', duration: 4000 });
      } finally {
        window.hideLoading();
      }
    },

    async onSubmit() {
      const willProceed = confirm("Before submitting this job, it is critical that you ensure that you are configuring the appropriate tasks (OTA updates, configuration changes, etc.) to deploy to the selected subset of devices. Press ok to continue, otherwise press cancel.");
      if (!willProceed) return;

      window.showLoading('Submitting job. Please wait...');
      try {
        const payload = this._buildJobPayload();
        const response = await Vue.prototype.$DeviceManagerAPIService.postJobs(payload);

        if (response && response.jobId) {
          this.$emit('exit', true);
          this.$toast.open({
            message: 'Job accepted. Job details will be available shortly.',
            type: 'success',
            duration: 3000
          });
        } else {
          this.$emit('exit', true);
          this.$toast.open({
            message: response && response.message ? response.message : 'No devices require updates.',
            type: 'warning',
            duration: 5000
          });
        }
      } catch (error) {
        console.error('Job submission failed:', error);
        this.$toast.open({ message: 'Failed to submit job. See console for details.', type: 'danger', duration: 5000 });
      } finally {
        window.hideLoading();
      }
    },

    _buildJobPayload() {
      return {
        tenant: getSelectedTenantValue(this.bedManagerService),
        batchSize: this.tasksForm.batchSize || this.batchSizeConfig.default,
        batchTimeoutMs: 30 * 60 * 1000,
        devices: Array.from(this.selectedDevices.values()).map((device) => {
          const attrs = this.expandedDeviceAttributes[device.deviceId] || {};
          return {
            deviceId: device.deviceId,
            mac: device.serial || (attrs && attrs.bedData && attrs.bedData.DeviceID) || '',
            firmwareVersion: attrs && attrs.version ? (attrs.version.GatewaySWVersionNumber || attrs.version.MainControllerSWVersion || '0.0.0') : '',
            area: device.areaId || device.area || '',
            unit: device.unitId || device.unit || '',
            location: device.locationId || device.location || '',
            metadata: attrs && attrs.bedData ? JSON.stringify(attrs.bedData) : ''
          };
        }),
        taskList: this.tasksForm.tasks.map((task) => {
          if (task.type == TaskType.OTA && task.payload && task.payload.package) {
            return {
              type: task.type,
              payload: { package: { _id: task.payload.package._id, version: task.payload.package.version } }
            };
          }
          if (task.type == TaskType.Configuration) {
            const payload = { Configuration: {} };
            Object.values(task.payload || {}).forEach((v) => {
              payload.Configuration[v.name] = v.value;
            });
            return { type: task.type, payload };
          }
          return null;
        }).filter(Boolean)
      };
    },
      onReset() {
      this.form = {
        label: "",
        version: "",
        file: null,
      }
    },
    packageListMutation(arr) {
      const mutated = new Set();
      const firmwareMap = new Map();

       arr.forEach(item => {
        if (item.packageType === 'Firmware') {
          let firmwareList = firmwareMap.get(item.label) || [];
          firmwareList.push(item);
          firmwareMap.set(item.label, firmwareList);
        } else mutated.add(item);
      });

       firmwareMap.forEach((value) => {
        const firmware = value.sort((a, b) =>
            a._id.localeCompare(b._id),
          )[value.length - 1];
        mutated.add(firmware);
      })

      return Array.from(mutated.values());
    },
    async fetchAllPackages() {
      try {
        const query = { queryFilter: 'available', limit: 30, sortProperty: 'created', sortDirection: 'desc' };
        const res = await Vue.prototype.$DeviceManagerAPIService.getPackages(query);
        const items = res && Array.isArray(res.items) ? res.items : [];
        this.packageOptions = this.packageListMutation(items);
      } catch (error) {
        console.error('fetchAllPackages error', error);
        this.packageOptions = [];
        throw error;
      }
    },
    packageOptionsForSource(source) {
      if (this.packageOptions && this.packageOptions.length) {
        return this.packageOptions.map((item) => ({ ...item, label: `${item.label} (${item.packageType} ${item.version})` }));
      }
      // fallback to existing service-provided source (when available)
      if (this.bedManagerService[source] && this.bedManagerService[source].data) {
        return this.packageListMutation(this.bedManagerService[source].data.filter(pkg => !pkg.isArchived)).map((item) => ({ ...item, label: `${item.label} (${item.packageType} ${item.version})` }));
      }
      return [];
    },
    toggleDevice(item) {
      const handler = (devices) => {
        let currentFormDevices = this.deviceForm.deviceIds;
        devices.forEach((device) => {
          if (device.deviceId) {
            if (this.deviceForm.deviceIds.includes(device.deviceId)) {
              this.selectedDevices.delete(device.deviceId);
              currentFormDevices = [ ...currentFormDevices.filter((id) => id !== device.deviceId)];
            } else {
              this.selectedDevices.set(device.deviceId, device);
              currentFormDevices = [ ...currentFormDevices, device.deviceId ];
            }
          }
          // filtering devices which are disabled
          if (device.disable) {
            currentFormDevices = [ ...currentFormDevices.filter((id) => id !== device.deviceId)];
            this.selectedDevices.delete(device.deviceId);
          }
        });
        this.deviceForm.deviceIds = currentFormDevices;
        this.selectedDevices = new Map(this.selectedDevices);
      }
      if (Array.isArray(item)) {
        const devices = item;
        handler(devices);
      } else {
        const device = item;
        handler([device]);
      }
    },
    removeAllDevices() {
      this.deviceForm.deviceIds = [];
      this.selectedDevices = new Map();
    },
    addTask(task) {
      if (task && POPUP_ONLY_TASK_TYPES.has(task.type)) return;
        if(task.type == TaskType.Configuration)
        if(this.tasksForm.tasks.some((t) => t.type == TaskType.Configuration)) return
      this.tasksForm.tasks = [ ...this.tasksForm.tasks, JSON.parse(JSON.stringify(task)) ];
      this.tasksForm.batchSize = this.batchSizeConfig.default;
      this.validateBatchSize();
    },
    removeTask(index) {
      try {
        this.tasksForm.tasks.splice(index, 1);
        this.tasksForm.tasks = [ ...this.tasksForm.tasks ];
        if (!this.tasksForm.tasks.length) {
          this.tasksForm.batchSize = null;
          this.$delete(this.errors, 'batchSize');
        }
      } catch { null }
    },
    incrementBatchSize() {
      const cfg = this.batchSizeConfig;
      const current = Number(this.tasksForm.batchSize) || 0;
      this.tasksForm.batchSize = Math.min(cfg.max, current + cfg.step);
      this.validateBatchSize();
    },
    decrementBatchSize() {
      const cfg = this.batchSizeConfig;
      const current = Number(this.tasksForm.batchSize) || 0;
      this.tasksForm.batchSize = Math.max(cfg.min, current - cfg.step);
      this.validateBatchSize();
    },
    onBatchSizeInput(value) {
      const parsed = Number(value);
      this.tasksForm.batchSize = Number.isFinite(parsed) ? Math.trunc(parsed) : null;
      this.validateBatchSize();
    },
    onBatchSizeBlur() {
      const cfg = this.batchSizeConfig;
      const value = Number(this.tasksForm.batchSize);
      this.tasksForm.batchSize = Number.isFinite(value)
        ? Math.min(cfg.max, Math.max(cfg.min, Math.trunc(value)))
        : cfg.default;
      this.validateBatchSize();
    },
    validateBatchSize() {
      const cfg = this.batchSizeConfig;
      const raw = this.tasksForm.batchSize;
      const value = Number(raw);
      let error = null;

      if (raw === null || raw === undefined || raw === '' || !Number.isFinite(value)) {
        error = 'Batch size is required.';
      } else if (!Number.isInteger(value)) {
        error = 'Batch size must be a whole number.';
      } else if (value < cfg.min) {
        error = `Batch size must be at least ${cfg.min}.`;
      } else if (value > cfg.max) {
        error = `Batch size must not exceed ${cfg.max}.`;
      }

      if (error) {
        this.$set(this.errors, 'batchSize', error);
      } else {
        this.$delete(this.errors, 'batchSize');
      }
      return !error;
    },
    selectTask(task) {
      this.selectedTask = task;
    },
    getTooltipMessage(device) {
      let message = '';
      if (device.disable) message = DisableTooltipMessage.DEVICE_INPROGRESS
      return message;
    },
    exportUnavailableDevices() {
      const headers = ['Device ID', 'Status'];

      const rows = this.computedAvailableDeviceList
      .filter(device => device.isOffline || device.disable)
      .map(d => [ d.deviceId.replace("cai:SYK", ""), d.isOffline ? 'Offline' : 'In-Progress']);

      const csvContent = [
        headers.join(','),
        ...rows.map(row => row.join(','))
      ].join('\n');

      this.bedManagerService.exportToCSV(csvContent, 'Unavailable_Devices_Report');
    },

    async openAdvancedFilters() {
      // Trigger the child's method using ref
      if (this.deviceForm.query.scope) {
        window.showLoading('Loading filter options...');
        try {
          const filterOptions = this.advancedFilterOptions.length > 0 ? this.advancedFilterOptions :
                                await this.bedManagerService.fetchComponentAndVersions(this.deviceForm.query.scope);
          window.hideLoading();

          const currentAdv = {
              operation: (this.deviceForm && this.deviceForm.query && this.deviceForm.query.operation) || 'AND',
              components: (this.deviceForm && this.deviceForm.query && this.deviceForm.query.components) || {},
          };
          this.$refs.filterDialog.setInputData(JSON.parse(JSON.stringify(currentAdv)), filterOptions);
          this.$refs.filterDialog.show();
          this.advancedFilterOptions = filterOptions;
        } catch (error) {
          window.hideLoading();
          console.error('Failed to fetch filter options:', error);
        }
      }
    },

    handleAdvancedFilterApplied(payload) {
      const { components, operation } = payload;
      const filters = Object.entries(components);
      if (filters.length === 0) {
        this.handleResetFilter();
        return;
      }
      
      // persist advanced filter into local query so it behaves like deviceId
      this.deviceForm.query.components = components;
      this.deviceForm.query.operation = operation;
      this.deviceForm.query = { ...this.deviceForm.query };
      
      // clear other filters before applying advanced filters but preserve advanced filter keys
      this.clearFilters(['components', 'operation']);

      // Trigger fetch with advanced filters applied. Include current deviceId if present.
      if (this.deviceForm.query.scope) {
        const overrides = { operation };
        if (components && Object.keys(components).length) overrides.components = JSON.stringify(components);
        this.bedManagerService.fetchCreateJobsDevices(this.deviceForm.query.scope, overrides);
      }
    },

    handleResetFilter() {
      const components = this.deviceForm.query.components || {};
      if (this.deviceForm && this.deviceForm.query) {
        this.deviceForm.query.components = {};
        this.deviceForm.query.operation = 'AND';
      }

      if (this.deviceForm.query.scope && Object.keys(components).length > 0) {
        // Reload without advanced filters
        const overrides = {};
        this.bedManagerService.fetchCreateJobsDevices(this.deviceForm.query.scope, overrides);
      }
    },
    // Clear an individual chip filter and re-fetch devices
    onChipClear(key) {
      try {
        if (!this.deviceForm || !this.deviceForm.query) return;

        if (key === 'deviceId') {
          this.deviceForm.query.deviceId = '';
        } else if (key === 'advanced') {
          this.deviceForm.query.components = {};
          this.deviceForm.query.operation = 'AND';
        } else if (key === 'location') {
          this.deviceForm.query.pocTree = null;
          this.deviceForm.query.searchValue = '';
          if (this.createJobsTreeField && Array.isArray(this.createJobsTreeField.treeData)) {
            const cloned = JSON.parse(JSON.stringify(this.createJobsTreeField.treeData || []));
            const sanitize = (nodes) => {
              if (!Array.isArray(nodes)) return;
              nodes.forEach(n => {
                n.selected = false; n.expanded = false; n.active = false;
                if (Array.isArray(n.children)) sanitize(n.children);
              });
            };
            sanitize(cloned);
            this.createJobsTreeField = { ...this.createJobsTreeField, treeData: cloned, filterActive: false };
          } else if (this.createJobsTreeField) {
            this.createJobsTreeField.filterActive = false;
          }
        }

        this.deviceForm.query = { ...this.deviceForm.query };

        if (this.deviceForm.query.scope) {
          this.bedManagerService.fetchCreateJobsDevices(this.deviceForm.query.scope, {});
        }
      } catch (err) {
        console.error('onChipClear error', err);
      }
    },
    // Called when ThemedLocationTree emits selection (Ok button). Map area ids -> unitIds/locationIds and apply filter.
    onLocationAreasChange(event) {
      try {
        this.deviceTreeVisible = false;
        const selectedAreaIds = Array.isArray(event) ? event : [];
        const unitIdsSet = new Set();
        const locationIdsSet = new Set();

        const tree = this.createJobsTreeField && this.createJobsTreeField.treeData ? this.createJobsTreeField.treeData : [];
        tree.forEach((facility) => {
          if (!facility || !Array.isArray(facility.children)) return;
          // If areas were emitted, map areas -> units/locations
          if (selectedAreaIds.length) {
            facility.children.forEach((unit) => {
              if (!unit || !Array.isArray(unit.children)) return;
              unit.children.forEach((area) => {
                if (area && selectedAreaIds.includes(area.id)) {
                  if (unit.id) unitIdsSet.add(unit.id);
                  if (facility.id) locationIdsSet.add(facility.id);
                }
              });
            });
          } else {
            // No areas emitted: infer from unit/facility selection (support Location-only or Location+Unit)
            if (facility.selected && facility.id) {
              locationIdsSet.add(facility.id);
            }
            facility.children.forEach((unit) => {
              if (unit && unit.selected && unit.id) unitIdsSet.add(unit.id);
            });
          }
        });

        const unitIds = Array.from(unitIdsSet);
        const locationIds = Array.from(locationIdsSet);

        
        // Persist the POC tree selection and the pending search so UI can rehydrate
        this.deviceForm.query.pocTree = { area: selectedAreaIds, unit: unitIds, location: locationIds };
        this.deviceForm.query.searchValue = this.deviceForm.query.searchValue || '';
        
        // Clear other filters but preserve the POC tree selection and pending search so tree state remains
        this.clearFilters(['pocTree', 'searchValue']);
        
        this.deviceForm.query = { ...this.deviceForm.query };

        // Update local header filterActive flag only (no side-effects on main POC)
        this.createJobsTreeField.filterActive = Boolean((selectedAreaIds && selectedAreaIds.length) || unitIds.length || locationIds.length);

        // Mark selected nodes in the local tree copy so the UI reflects the selection
        try {
          if (this.createJobsTreeField && Array.isArray(this.createJobsTreeField.treeData)) {
            const markNodes = (nodes) => {
              if (!Array.isArray(nodes)) return;
              nodes.forEach((facility) => {
                facility.selected = !!(facility.id && locationIds.includes(facility.id));
                if (Array.isArray(facility.children)) {
                  facility.children.forEach((unit) => {
                    unit.selected = !!(unit.id && unitIds.includes(unit.id));
                    if (Array.isArray(unit.children)) {
                      unit.children.forEach((area) => {
                        area.selected = !!(area.id && selectedAreaIds.includes(area.id));
                      });
                    }
                  });
                }
              });
            };
            const clonedTree = JSON.parse(JSON.stringify(this.createJobsTreeField.treeData || []));
            markNodes(clonedTree);
            this.createJobsTreeField = { ...this.createJobsTreeField, treeData: clonedTree };
          }
        } catch (e) {
          // ignore
        }

        // Trigger filtered fetch (pass arrays; server accepts arrays or comma-strings)
        if (this.deviceForm.query.scope) {
          const overrides = {
            location: locationIds,
            unit: unitIds,
            area: selectedAreaIds,
          };
          this.bedManagerService.fetchCreateJobsDevices(this.deviceForm.query.scope, overrides);
        }
      } catch (err) {
        console.error('onLocationAreasChange error', err);
      }
    },
    onLocationTreeSearchChange(event) {
      if (!event) return;
      // Store search into the device query; apply immediately for persistence
      try {
        this.deviceForm.query.searchValue = event || '';
      } catch (err) { console.error('onLocationTreeSearchChange error', err); }
    },
    // Ordered, curated keys present on this payload for its task type; hides any other field
    previewKeysForTask(task, payload) {
      if (!payload) return [];
      const labels = task.type === TaskType.OTA ? OTA_PREVIEW_LABELS : CONFIGURATION_PREVIEW_LABELS;
      return Object.keys(labels).filter((key) => Object.prototype.hasOwnProperty.call(payload, key));
    },
    previewLabelForTask(task, propKey) {
      const labels = task.type === TaskType.OTA ? OTA_PREVIEW_LABELS : CONFIGURATION_PREVIEW_LABELS;
      return labels[propKey];
    },

    openSkippedDevicesModal(skipped) {
      this.skippedDevices = skipped;
      this.skippedDevicesModalVisible = true;
    },

    onSkippedDevicesModalClosed() {
      this.skippedDevicesModalVisible = false;
      this.skippedDevices = [];
      this.skippedDevicesSearch = '';
      // Do not exit — user lands on Preview tab with remaining devices
    }


  },
   beforeDestroy() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
    // Reset skipped devices modal state
    this.skippedDevicesModalVisible = false;
    this.skippedDevices = [];
    this.skippedDevicesSearch = '';
  }
};
</script>

<style lang="scss">
 .create-jobs__main {
    .create-jobs__tab-content {
      .tab-pane {
        height: 550px;
        overflow: visible;
      }
    }
    .close_btn {
      height: 20px;
      width: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      transition: all 500ms;
      background-color: #effefe;
      border: 1px solid rgba(0, 181, 218, 0.4);
      color: #c8c8c8;
      padding-bottom: 2px;
      border-radius: 50%;
    }

    .create-jobs__time-input {
      width: 4.5rem;

      //Disable input slider ui
      appearance: textfield;
      -moz-appearance: textfield;
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
    .create-jobs__time-field {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .create-jobs__time-label {
      font-size: 11px;
      color: #888;
      margin-top: 2px;
    }
    .multiselect__single {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 235px;
    }
    .multiselect__tags {
      height: 38px;

      .multiselect__placeholder {
        padding-top: 0px !important;
      }

      input {
        padding-left: 0
      }

      input::placeholder {
        font-size: 14px;
        font-weight: 400;
        color: #b6b6b6;
        padding-left: 0px;
      }
    }

  .multiselect__content-wrapper {
    .multiselect__element {
       span {
          font-size: 14px;
          font-weight: 400;
          color: #424242;
        }
          }
  }

  .create-jobs__filter-devices {
    position: relative;
    padding: 7px;
    border-radius: 3px;
    background: #fff;
    transition: all .25s;
    border: 1px solid #ebebeb;
    color: #b1b1b1;
    height: 38px;
    font-weight: 500;

    &:disabled {
        background: #fff !important;
        border-color: #ebebeb !important;
        color: #b1b1b1 !important;
        cursor: not-allowed;
      }

      &:hover {
        color: white;
        border-color: #1dd8f6;
        background: #1dd8f6;
      }
    }

  .filter-label {
   position: absolute; top: 7px; left: 15px;
  }

    .create-jobs__filter-chip {
      position: absolute;
      width: max-content;
      left: 90%;
      top: 9%;
      transform: translate(-50%, -50%);
      background: #1dd8f6; /* match multiselect tag */
      border: 1px solid rgba(0,181,218,.4);
      margin-top: 0px;
      padding: 4px 8px;
      border-radius: 12px;
      font-size: 12px;
      color: #fff;
      cursor: pointer;
      transition: all 150ms;
      box-shadow: none;
    }

     .card-body > div > small, .create-jobs__tab-pane > small {
      color: #3288D2;
    }

    .card-body > div > small {
      position: absolute;
      top: 8px;
    }

    .nav-tabs {
      border-bottom: 1px solid #e6e6e6 !important;
      padding: 0 15px;
    }

    .nav-tabs .dm__tab-link {
    color: #959595;
    transition: color 500ms;
    border: none;
    font-size: 15px;

      &:hover {
        color: #1dd8f6;
      }

      &.active {
        color: #1dd8f6;
        border-color: #1dd8f6;
        border-bottom: 3px solid #1dd8f6;
      }
    }

    .form-buttons {
      display: flex;
      padding: 5px;
      justify-content: space-between;
      align-items: center;

      .btn-secondary {
        background-color: #f27778;
      }
    }


  label { color: #404040; }
  .card { border: none; }
  .create-jobs__helper { background: #f2f2f2; color: #a9a9a9; font-size: 12px; border: none; border-bottom: 1px solid rgb(210 210 210 / 13%); }
  .header {display: flex; justify-content: space-between; padding-bottom: 5px;}
  .multiselect__tag { background: #1dd8f6; }
  .multiselect__tag-icon:focus, .multiselect__tag-icon:hover { background: #18bdd6; }
  .multiselect__tag-icon:after { color: white; }
  .multiselect__option--highlight::after { display: none; }
  .multiselect__option--selected { background-color: #f2fdfe; }
  .multiselect__option--selected::after { display: none; }
  .multiselect__option--highlight { background-color: #f2fdfe; color: #787878; }
  .create-jobs__btn { text-align: end; color: #3288D2; cursor: pointer; }
     .create-jobs__tab-pane {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 5px;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 0;

      .create-jobs__tab-pane--item {
        display: flex;
        flex-direction: column;
        gap: 5px;
        justify-content: center;
        align-items: flex-start;
        padding: 5px;
        flex: 1;
        min-width: 200px;

        .tenant-select {
          option:first-of-type {
            display: none;
          }
        }

        .form-control {
          border-color: #e8e8e8;
          padding: .25rem .5em;

          &::placeholder {
            font-size: 12px;
            font-weight: 500;
            color: #b6b6b6;
          }
        }
      }

      .create-jobs__tab-pane--available-selected {
        width: 100%;
        padding: 15px;
        border-radius: 5px;
        border: none;
        position: relative;

        .create-jobs__tab-pane--available-selected-divider {
          position: absolute;
          top: 0;
          bottom: 0;
          border-left: 1px solid #e6e6e6;
          width: 1px;
          left: 50%;
        }

        > div {
          display: flex;
          flex-direction: row;
          gap: 5px;
          justify-content: flex-end;
          align-items: flex-start;
          padding: 0px;
          flex-wrap: wrap;

          > div {
            width: 49%;
          }
        }
      }

      .create-jobs__tab-pane--list {
        display: flex;
        flex-direction: column;
        gap: 5px;
        max-height: 400px;
        min-height: 400px;
        overflow-y: auto;
        margin-top: 15px;
        overflow-x: hidden;
        min-width: 0;
      }

      .create-jobs__tab-pane--items {
        display: flex;
        justify-content: space-between;
        width: 100%;
        border-bottom: 1px solid #e6e6e6;
        padding: 10px;
        padding-top: 20px;
        flex-wrap: wrap;
      }
      .create-jobs__tab-pane--list-item {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 5px;
        padding: 0 5px;
        min-width: 0;

        small {
          flex: 1 1 auto;
          min-width: 150px;
        }
      }

      .create-jobs__tab-pane--list-item-text {
        display: flex;
        flex-direction: column;

        > span {
          font-size: 12px;
          color: #aaaaaa;
        }
      }

      .create-jobs__tab-pane--list-available-item-text {
        flex: 1;
        display: block;
        font-size: small;
        height: 20px;
        padding: 0 5px;
        border-radius: 3px;
        border-left: 3px solid transparent;
        transition: all 200ms;

        &:hover {
          background-color: #1dd8f6;
          cursor: pointer;
        }

        &.create-jobs__available-item--selected {
          background-color: rgba(29, 216, 246, 0.15);
          border-left-color: #1dd8f6;
        }

        &.create-jobs__available-item--added {
          background-color: #1dd8f6;
          color: #fff;
          font-weight: 500;
          border-left-color: #18bdd6;
        }

        &.create-jobs__available-item--disabled {
          opacity: 0.4;
          cursor: not-allowed;
          pointer-events: none;

          &:hover {
            background-color: transparent;
          }
        }
      }

      .create-jobs__row-button {
          height: 25px;
          width: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0;
          transition: all 500ms;
          background-color: #effefe;
          border: 1px solid rgba(0,181,218,.4);
          color: #c8c8c8;
          font-weight: 200;
          font-size: 12px;

          &:disabled {
            background-color: #ebebeb;
            color: #a5a5a5;
            cursor: not-allowed;
          }

          &:not(:disabled):hover {
              background-color: #1dd8f6;
              color: white;
          }
      }

      .create-jobs__batch-processing {
        width: 100%;
        flex-basis: 100%;
        margin-top: 15px;
        padding: 10px;
        border: 1px solid #e6e6e6;
        border-radius: 6px;
      }

      .create-jobs__batch-processing-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-top: 8px;

        label {
          margin: 0;
          font-size: 12px;
          color: #575757;
        }
      }

      .create-jobs__batch-size-input {
        max-width: 90px;
        text-align: center;

        //Disable native number input spinner (custom +/- buttons are used instead)
        appearance: textfield;
        -moz-appearance: textfield;
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }

      .create-jobs__batch-processing-hint {
        display: block;
        color: #aaaaaa;
        margin-top: 5px;
      }

      .create-jobs__submit-btn {
          background-color: #1dd8f6;
          color: white;
          border: none;
          font-weight: 400;
          width: 90px;
          &:hover {
            background-color: #1dd8f6;
            color: white;
          }
          &:disabled {
            background-color: #ebebeb;
            color: #a5a5a5;
            cursor: not-allowed;
          }
        }

      .create-jobs__tab-pane--payload-preview {
        display: flex;
        flex-direction: column;
        min-width: 0;

        span, strong, small {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal; /* allow wrapping to avoid forcing modal width */
          min-width: 0;
          word-break: break-word;
          overflow-wrap: anywhere;
        }

        .create-jobs__tab-pane--payload-preview-prop {
          color: #aaa;
          font-size: 12px;
        }
      }

      .create-jobs__task-preview {
        width: 100%;
        min-width: 0;
        max-height: 360px;
        overflow-y: auto;
        overflow-x: hidden;
      }

      .create-jobs__task-heading {
        font-size: 16px;
        font-weight: 700;
        color: #3288D2;
        margin-bottom: 6px;
      }

      .create-jobs__task-table {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
        margin-bottom: 10px;
        font-size: 12px;

        tr {
          border-bottom: 1px solid #e6e6e6;
        }

        td {
          padding: 5px 8px;
          vertical-align: top;
        }

        .create-jobs__task-table-label {
          font-weight: 600;
          color: #575757;
          width: 35%;
          white-space: nowrap;
        }

        .create-jobs__task-table-value {
          color: #333;
          word-break: break-word;
          overflow-wrap: anywhere;
        }
      }
    }
  }
  .bm-modal {
    font-size: 13px;
    color: #5f5f5f;
    z-index: 2000;
    /* Prevent modal from growing when internal content changes */
    .bm-modal__dialog { max-width: 820px !important; width: 820px !important; }
    .bm-modal__content { border-radius: 6px; font-family: inherit !important; overflow-x: hidden; }
    .bm-modal__header {
      border-bottom: 1px solid #e6e6e6;
      padding: 12px 15px;
      .modal-title { font-size: 16px; font-weight: 600; color: #2f2f2f; }
    }
    .bm-modal__body { padding: 10px 14px 12px; display: flex; flex-direction: column; height: 580px; max-height: calc(100vh - 220px); overflow: hidden; }
    /* Stronger constraints to prevent internal content from growing modal width */
    &.modal, & {
      overflow-x: hidden !important;
    }
    .modal-dialog,
    .bm-modal__dialog,
    &.modal .modal-dialog {
      width: 820px !important;
      max-width: 820px !important;
      min-width: 820px !important;
      box-sizing: border-box !important;
    }
    .modal-content,
    .bm-modal__content {
      overflow-x: hidden !important;
    }
    .bm-modal__table .table,
    .bm-modal__table table {
      table-layout: fixed !important;
      width: 100% !important;
      word-break: break-word !important;
      white-space: normal !important;
    }
    .create-jobs__tab-content,
    .create-jobs__tab-pane,
    .create-jobs__tab-pane--list {
      min-width: 0 !important;
      overflow-x: hidden !important;
    }
    .bm-modal__topbar { display: flex !important; align-items: center; width: 100%; flex-wrap: nowrap; gap: 10px; }
    .bm-modal__badges {

    .badge {
      font-size: 11px !important; font-weight: 400 !important; padding: 6px 10px !important; border-radius: 4px;
    }

    .badge-warning {
      background-color: #f6c343 !important; color: #000 !important;
    }

    .badge-info {
      background-color: #17a2b8 !important; color: #fff !important;
    }
  }
    .table, .table th, .table td, .modal-title, .bm-modal__topbar, .bm-modal__badges, .bm-modal__download, .bm-modal__send-request {
      font-family: inherit !important;
      font-size: 13px;
      font-weight: 400;
      color: #404040;
    }
    .bm-modal__download {
      margin-left: auto !important;
      height: 28px;
      padding: 0 12px;
      border-radius: 4px;
      font-size: 13px;
      font-weight: 500  !important;
      border: 1px solid rgba(0, 181, 218, .4);
      background-color: #effefe;
      color: #5f5f5f;
      cursor: pointer;
      transition: all 300ms;
      &:hover { background-color: #1dd8f6; color: white; }
    }
    .bm-modal__fixed-area { flex: 1 1 auto; min-height: 0; max-height: none; overflow: hidden; }
    /* b-tabs inserts a wrapper div.tabs between fixed-area and the tab content;
       build a continuous flex column so heights resolve down to the scroll area. */
    .bm-modal__fixed-area > .tabs { display: flex; flex-direction: column; height: 100%; min-height: 0; }
    .bm-modal__tabs { padding: 0; border-bottom: 1px solid #e6e6e6 !important; flex: 0 0 auto; }
    .bm-modal__tabs-content { flex: 1 1 auto; min-height: 0; overflow: hidden; }
    /* Make the active tab pane a flex column so the table scroll area fills the
       space left after the (optional) action bar, keeping the last row reachable. */
    .bm-modal__tabs-content > .tab-pane.active { display: flex; flex-direction: column; height: 100%; min-height: 0; }
    .bm-modal__userack-actions { flex: 0 0 auto; }
    .bm-modal__table { flex: 1 1 auto; min-height: 0; display: flex; flex-direction: column; margin-bottom: 0; }
    .bm-modal__table.b-table-sticky-header,
    .bm-modal__table .b-table-sticky-header,
    .bm-modal__table .table-responsive { flex: 1 1 auto; max-height: none; height: 100%; min-height: 0; overflow-y: auto; }
    .bm-modal__table thead th { position: sticky; top: 0; background: #fff; z-index: 3; color: #404040; font-weight: 600; border-bottom: 1px solid #e6e6e6; }
    .bm-modal__table thead th.b-table-sort-icon-left[aria-sort="none"]::before { display: inline-block !important; opacity: 0.35; }
    /* sticky-header wraps <table> in a div that carries bm-modal__table, so .table.b-table is a descendant, not the same element */
    .bm-modal__table .table.b-table > thead > tr > [aria-sort] {
      cursor: pointer;
      background-image: none !important;
    }
    /* th must stay display:table-cell for column layout, so the flex alignment goes on the label div bootstrap-vue renders instead */
    .bm-modal__table .table.b-table > thead > tr > [aria-sort] > div {
      display: flex;
      align-items: center;
    }
    /* CSS-only glyph (matches ThemedTable.vue's sort icon family) placed inline right after the label so it stays visible regardless of column width */
    .bm-modal__table .table.b-table > thead > tr > [aria-sort] > div::after {
      content: '\21F5';
      display: inline-block;
      margin-left: 0.35rem;
      font-size: 0.75em;
      opacity: 0.45;
    }
    .bm-modal__table .table.b-table > thead > tr > [aria-sort=ascending] > div::after {
      content: '\2191';
      opacity: 1;
    }
    .bm-modal__table .table.b-table > thead > tr > [aria-sort=descending] > div::after {
      content: '\2193';
      opacity: 1;
    }
    .bm-modal__userack-actions { display: flex !important;  align-items: center!important; gap: 10px !important;padding: 6px 0 14px 0!important;}
    .bm-modal__send-request {
      height: 28px;
      padding: 0 12px;
      border-radius: 4px;
      font-size: 11px;
      font-weight: 500;
      border: 1px solid rgba(0, 181, 218, .4);
      background-color: #effefe;
      color: #5f5f5f;
      cursor: pointer;
      transition: all 300ms;
      &:disabled { background: #ebebeb !important; color: #a5a5a5 !important; cursor: not-allowed; }
      &:not(:disabled):hover { background-color: #1dd8f6; color: white; }
    }
    .bm-modal__search {
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 10px 0 6px;
}

.bm-modal__search .form-control {
  height: 32px;
  font-size: 13px;
}
.bm-modal__table input:disabled {
  opacity: 0.6;
}

.bm-modal__clear {
  height: 32px;
  padding: 0 12px;
  border-radius: 4px;
  border: 1px solid rgba(0, 181, 218, .4);
  background-color: #effefe;
  color: #5f5f5f;
  transition: all 300ms;

  &:disabled {
    background: #ebebeb !important;
    color: #a5a5a5 !important;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    background-color: #1dd8f6;
    color: white;
  }
}
    .bm-modal__userack-hint { color: #9a9a9a; font-size: 11px; }
    .bm-modal__footer-actions {
      display: flex;
      justify-content: flex-end;
      padding-top: 10px;
    }
  }

  // Responsive adjustments for smaller laptop / low-viewport heights
  @media (max-width: 1366px), (max-height: 820px) {
    .bm-modal {
      .bm-modal__dialog { width: 92vw; max-width: 720px; }
      .bm-modal__body { height: 540px; max-height: calc(100vh - 160px); overflow: hidden; }
      .bm-modal__fixed-area { flex: 1 1 auto; min-height: 0; max-height: none; overflow: hidden; }
      .bm-modal__tabs-content { flex: 1 1 auto; min-height: 0; overflow: hidden; }
    }
  }

  .skipped-devices-table {
    height: 320px;
    overflow-y: auto;
  }
  .bm-device-row {
  align-items: flex-start;
}

.bm-device-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.bm-device-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 2px 4px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: #f2fdfe;
  }
}

.bm-device-title {
  display: flex;
  flex-direction: column;
  min-width: 0;

  strong {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    font-size: 12px;
    color: #aaaaaa;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.bm-device-chevron {
  font-size: 11px;
  color: #888;
  flex: 0 0 auto;
}

.bm-device-details {
  margin-top: 6px;
  padding-left: 4px;
}

.bm-select-all-text {
  text-align: end;
  color: #3288D2;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  transition: color 200ms;

  &:hover {
    color: #1dd8f6;
  }
}

/* Constrain the themed location tree viewport so it doesn't overflow the screen */
.careai__themed-location-tree div .careai__themed-tree-viewport {
  max-height: calc(100vh - 68vh) !important;
}

// Firmware version table styles
.fw-table {
  margin-top: 8px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e0e0e0;

  .fw-title {
    font-size: 12px;
    font-weight: 600;
    color: #3288D2;
    margin: 0 0 8px 0;
    padding-bottom: 4px;
    border-bottom: 1px solid #e0e0e0;
  }

  .fw-grid {
    width: 100%;
    border-collapse: collapse;
    font-size: 11px;

    thead th {
      background: #e8f4f8;
      color: #3288D2;
      font-weight: 600;
      padding: 6px 8px;
      text-align: left;
      border-bottom: 2px solid #3288D2;
    }

    tbody tr {
      border-bottom: 1px solid #e0e0e0;

      &:hover {
        background: #f0f8ff;
      }

      td {
        padding: 5px 8px;

        &.fw-label {
          color: #575757;
          font-weight: 500;
          width: 45%;
        }

        &.fw-value {
          color: #333;

          &.fw-has {
            color: #28a745;
            font-weight: 500;
          }

          &.fw-missing {
            color: #999;
          }
        }
      }
    }
  }

  .fw-empty {
    color: #999;
    font-style: italic;
  }

  .fw-no-info {
    display: block;
    padding: 12px;
    color: #999;
    font-size: 12px;
    text-align: center;
  }

  // Bed data rows inside the firmware table
  .bd-row {
    border-top: 1px dashed #d0d0d0;
  }

  .bd-key {
    color: #575757;
    font-weight: 500;
    width: 45%;
    word-break: break-word;
  }

  .bd-value {
    color: #333;
    word-break: break-word;

    &.bd-has {
      color: #28a745;
      font-weight: 500;
    }

    &.bd-missing {
      color: #999;
    }
  }

  .bd-empty {
    color: #999;
    font-style: italic;
  }

  // Inline "no info" message
  .bm-device-loading {
    display: flex;
    align-items: center;
    padding: 12px;
    color: #999;
    font-size: 12px;
  }
}
</style>
